import { useSelector } from 'react-redux';
import Messages from 'i18n/messages/home';

import { PlayCircleOutlined } from '@ant-design/icons';

import { forwardTo } from 'utils/common/route';
import RibbonButton from 'common/components/button/RibbonButton';
import gridSelector from 'common/components/grid-view/controllers/selectors';

const OpenTicketingSystem = () => {
  const selectedDetail = useSelector(
    gridSelector.makeSelectDetailCurrentITemsSelection()
  );
  const id =
    selectedDetail && selectedDetail.length > 0
      ? selectedDetail[0].id
      : undefined;

  return (
    <RibbonButton
      icon={<PlayCircleOutlined />}
      label={Messages.openTiketingSystem}
      onClick={() => forwardTo(`/ticketing-system/${id}`)}
      disabled={id === undefined || selectedDetail.length !== 1}
    />
  );
};

export default OpenTicketingSystem;
